<template lang="pug">
div
  .card(style="position: sticky; top: -75px; z-index: 9;")
    .card-header
      .h4 Detalhes da análise
    .card-body
      .columns
        item-col.col-8.col-sm-12.mt-2(label="Assunto da OS-m" :value="analise.ordem_servico.assunto.descricao" v-if="analise.ordem_servico.assunto")
        .column.col-auto(style="margin-top: 25px")
          span(:class="analiseSituacaoClass(analise.situacao) + ' label'")
            | {{ $i18n.t(`enums.db.enum_ordem_servico_analise_situacao.${analise.situacao}`) }}
      .columns
        item-col.col-4.col-sm-12.mt-2(label="OS-m número" :value="`${analise.ordem_servico.numero}/${analise.ordem_servico.ano}`")
        item-col.col-4.col-sm-12.mt-2(label="Emissão da OS-m" :value="analise.ordem_servico.created_at | date")
        item-col.col-4.col-sm-12.mt-2(label="ordem_servico_analise.created_at" :value="analise.created_at | date")
        item-col.col-12.mt-2(label="ordem_servico_analise.analista" :value="analise.analista.nome")
  .card.mt-2(v-if="analise.eventos.length")
    .card-header
      .h4 Eventos da análise
    .card-body
      .columns.mb-2(
        v-for="(evento, index) in analise.eventos",
        :key="evento.id"
      )
        .column
          small 
            span.label
              | {{ $i18n.t(`enums.db.enum_ordem_servico_analise_situacao.${evento.situacao}`) }}          
            span  -
            b  {{ evento.usuario.login | cpfCnpj }} - {{ evento.usuario.nome }}
        .column.col-auto
          small {{ evento.created_at | date }}
        .column.col-12 {{ evento.parecer }}
        .column.col-12.divider(v-if="index + 1 < analise.eventos.length")
  .card.mt-2
    .card-header
      .h4 Mais informações da OS-m
    .card-body
      .columns
        item-col.col-6.col-sm-12.mt-2(label="ordem_servico.protocolo_tipo" :value="analise.ordem_servico | enums('ordem_servico.protocolo_tipo')")
        item-col.col-6.col-sm-12.mt-2(
          label="Protocolo" :value="`${String(analise.ordem_servico.protocolo_numero) || '-'}/${String(analise.ordem_servico.protocolo_ano) || '-'}`"
        )
        item-col.col-4.col-sm-12.mt-2(label="ordem_servico.situacao" :value="analise.ordem_servico | enums('ordem_servico.situacao')")
        item-col.col-4.col-sm-12.mt-2(label="ordem_servico.comentario_situacao" :value="analise.ordem_servico.comentario_situacao.descricao" v-if="analise.ordem_servico.comentario_situacao")
        item-col.col-4.col-sm-12.mt-2(label="ordem_servico.concluido_em" :value="analise.ordem_servico.concluido_em | date")
        item-col.col-12.mt-2(label="ordem_servico.usuario" :value="analise.ordem_servico.usuario.nome" v-if="analise.ordem_servico.usuario")
        item-col.col-12.mt-2(label="ordem_servico.usuario_responsavel" :value="analise.ordem_servico.usuario_responsavel.nome" v-if="analise.ordem_servico.usuario_responsavel")
        .divider.column.col-12.text-center(:data-content="'ordem_servico.cadastro' | tModel")
        item-col.col-6.mt-2(label="cadastro.numero" :value="analise.ordem_servico.cadastro.numero")
        item-col.col-6.mt-2(label="cadastro.tipo" :value="analise.ordem_servico.cadastro | enums('cadastro.tipo')")
        item-col.col-4.mt-2(label="cadastro.zona" :value="analise.ordem_servico.cadastro.zona")
        item-col.col-4.mt-2(label="cadastro.quadra" :value="analise.ordem_servico.cadastro.quadra")
        item-col.col-4.mt-2(label="cadastro.lote" :value="analise.ordem_servico.cadastro.lote")
        item-col.col-12.mt-2(label="cadastro.contribuinte" :value="contribuinteLabel")
        .column.col-12.columns(v-if="analise.ordem_servico.info && analise.ordem_servico.info.obs")
          .divider.column.col-12
          item-col.col-12.mt-2(label="ordem_servico_info.obs" :value="analise.ordem_servico.info.obs")
    .card-footer.text-right(v-acl:allowed.admin.ordem_servicos.show)
      router-link.btn.btn-link.btn-sm(:to="{ name: 'app.osm.servicos.show', params: { id: analise.ordem_servico_id } }" target="_blank")
        i.fa.fa-eye
        |  Ver OS-m
  .card.mt-2(v-if="analise.ordem_servico.docs.length")
    .card-header
      .h4 Documentos da OS-m
    .card-body
      div(v-for="doc in analise.ordem_servico.docs")
        span Documento Nº
        router-link.c-hand(:to="{name: 'fiscalizacao.docs.show', params: {id: doc.id}}" target="_blank")
          |  {{ doc.numero }}/{{ doc.ano}}
  .card.mt-2(v-if="analise.ordem_servico.anexos.length")
    .card-header
      .h4 Anexos da OS-m
    .card-body
      .columns.bg-gray.mb-2.py-2(v-for="anexo in analise.ordem_servico.anexos")
        .column.col-auto
          img.img-responsive.s-rounded(:src="anexo.thumb" style="width: 80px;")
        .column
          div #[b {{ anexo.descricao || anexo.file_info.name }}]
          small
            div Nome original: {{ anexo.file_info.name }}
            div Tamanho: {{ anexo.file_info.size / 1000 | currency }} Kb
        .column.col-auto 
          a.c-hand(:href="anexo.url" target="_blank")
            i.fa.fa-external-link
  .card.mt-2
    .card-body
      show-checklist(:checklist="checklist" :comentario_situacao="analise.ordem_servico.comentario_situacao")
  .card.mt-2
    .card-body
      .h4 Resultado
      .text-warning(v-if="totalCondicoes === 0") Checklist sem nenhuma referência
      div(v-else)
        div Total de referências: #[b {{ totalCondicoes }}]
        .text-error(v-if="totalInvalidos > 0") {{ `${totalInvalidos} ${totalInvalidos > 1 ? 'respostas estão fora da referência' : 'resposta está fora da referência'}` }}
        .text-success(v-else) Todas as perguntas estão dentro da referência
</template>

<script>
import ShowChecklist from "./checklist/Show.vue"
import { analiseSituacaoClasses } from "@/lib/constants"
import referencias from "@/lib/checklistReferencia"
import { cpfCnpj } from "@/lib/masks"

export default {
  props: { analise: { type: Object, required: true } },
  components: { ShowChecklist },
  computed: {
    contribuinteLabel() {
      const { contribuinte } = this.analise.ordem_servico.cadastro
      return `${cpfCnpj(contribuinte.cpf_cnpj)} - ${contribuinte.razao_social}`
    },
    checklist() {
      return this.analise.comentario.checklist || {}
    },
    totalCondicoes() {
      const grupos = Object.values(this.checklist)
      let count = 0
      for (const grupo of grupos) {
        const perguntas = Object.values(grupo.perguntas)
        for (const pergunta of perguntas) {
          if (pergunta.referencia_resposta)
            count += pergunta.referencia_resposta.condicoes.length
        }
      }
      return count
    },
    totalInvalidos() {
      const grupos = Object.values(this.checklist)
      let count = 0
      for (const grupo of grupos) {
        const perguntas = Object.values(grupo.perguntas)
        for (const pergunta of perguntas) {
          if (pergunta.referencia_resposta) {
            for (const condicao of pergunta.referencia_resposta.condicoes) {
              const { validacao } = referencias.find(
                referencia => referencia.operacao === condicao.operacao,
              )
              if (["checkbox", "radio"].includes(pergunta.tipo)) {
                for (const alternativaId of pergunta.resposta.length
                  ? pergunta.resposta
                  : [pergunta.resposta]) {
                  const valido = validacao(condicao.esperado, alternativaId)
                  if (!valido) {
                    count += 1
                    break
                  }
                }
              } else {
                const valido = validacao(condicao.esperado, pergunta.resposta)
                if (!valido) count += 1
              }
            }
          }
        }
      }
      return count
    },
    totalValidos() {
      return this.totalCondicoes - this.totalInvalidos
    },
  },
  methods: {
    analiseSituacaoClass(situacao) {
      return analiseSituacaoClasses[situacao]
    },
  },
}
</script>
